import { useApi } from './useApi';
import { useState, useEffect } from 'react';

export const useProducts = (category = '', search = '', page = 1) => {
  const api = useApi();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await api.get('/products', {
          params: { category, search, page, limit: 12 },
        });
        setProducts(response.data.products);
        setTotal(response.data.total);
        setPages(response.data.pages);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [category, search, page, api]);

  return { products, loading, error, total, pages };
};
